import { Button, MenuItem, Select, Switch, Typography } from '@mui/material'
import React from 'react'
import { useAdvancedSearchStore } from '../hooks/useAdvancedSearch'
import { getCookie } from '../../../utils/cookieHandle';
import { RequestNextApi } from '../../../api/Request';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';
import { ProgressContext } from '../../Context/progressContext';

function Submission({ onSubmit, onClear, resultsCount }) {
    const { update: updateProgress } = React.useContext(ProgressContext);

    const returnTypes = useAdvancedSearchStore(s => s.returnTypes);
    const selectedType = useAdvancedSearchStore(s => s.returnType);
    const searchMode = useAdvancedSearchStore(s => s.searchMode);
    const changeSelectedType = useAdvancedSearchStore(s => s.changeReturnType);

    const selectedCompareCondition = useAdvancedSearchStore(s => s.compareCondition);
    const changeCompareCondition = useAdvancedSearchStore(s => s.changeCompareCondition);

    const setShowAdvanceFilter = useAdvancedSearchStore(s => s.setShowAdvanceFilter)
    const setSearchMode = useAdvancedSearchStore(s => s.setSearchMode)

    const setHasSearchedAdvanced = useAdvancedSearchStore(s => s.setHasSearchedAdvanced)
    const hasSearchedAdvanced = useAdvancedSearchStore(s => s.hasSearchedAdvanced)

    const constructPayloadAndSubmit = async () => {
        setSearchMode("ADVANCED")
        await (async () => new Promise((resolve) => {
            setTimeout(() => { resolve() }, 400)
        }))()
        const payload = useAdvancedSearchStore.getState().getPayloadForApi()
        delete payload.extended_fields
        const isSuccess = await onSubmit(payload)
        if (isSuccess) {
            setHasSearchedAdvanced(true)
        }
    }

    const onSendEmail = async () => {
        try {
            updateProgress({ isLoading: true });
            const payload = useAdvancedSearchStore.getState().getPayloadForApi()
            const res = await RequestNextApi.post(
                "/user/member-advanced-email-search-staff",
                {
                    ...payload,
                    jwtToken: getCookie("jwt-token"),
                }
            );
            if (res.data && res.data.success) {
                ShowNotification.success(res.data.message || "Email sent successfully!");
            } else {
                ShowNotification.error(res.data?.message || "Failed to send email!");
            }
        } catch (e) {
            ShowNotification.error("Something went wrong! Please try again.");
        } finally {
            updateProgress({ isLoading: false });
        }
    };


    return (
        <div className='flex flex-1 justify-end mx-[50px]'>
            <div className='flex flex-col items-end'>
                <div className='flex justify-end bg-white w-fit p-2 items-center'>
                    <div>
                        <span>
                            Compare Condition:
                        </span>
                    </div>
                    <div className='flex space-x-2 items-center mx-4'>
                        <span>Any</span>
                        <Switch
                            color='secondary'
                            checked={selectedCompareCondition === "ALL"}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    changeCompareCondition("ALL")
                                } else {
                                    changeCompareCondition("ANY")
                                }
                            }}
                        />
                        <span>All</span>
                    </div>
                </div>
                <div className='flex mt-6'>
                    <div className='flex'>
                        <Button variant='contained' className='bg-secondary-500 hover:bg-secondary-500 ml-4 w-[100px]' onClick={() => {
                            onClear?.()
                        }}>
                            Clear
                        </Button>
                        <Button variant='contained' className='bg-secondary-500 hover:bg-secondary-500 ml-4 w-[100px]' onClick={() => {
                            constructPayloadAndSubmit()
                        }}>
                            Search
                        </Button>
                    </div>
                </div>
                {searchMode === "ADVANCED" && hasSearchedAdvanced && <div className='flex mt-6'>
                    <div className='flex justify-center items-center mr-4'>
                        <Typography>
                            Your search produced {resultsCount} results
                        </Typography>
                    </div>
                    <Select
                        fullWidth
                        value={selectedType}
                        MenuProps={{
                            style: { zIndex: 35001 }
                        }}
                        className=' w-[200px]'
                        onChange={(e) => {
                            changeSelectedType(e.target.value)
                        }}
                    >
                        {returnTypes.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                    <div className='flex'>
                        <Button variant='contained' className='bg-secondary-500 hover:bg-secondary-500 ml-4 w-[100px]' onClick={() => {
                            onSendEmail()
                        }}>
                            Email Results
                        </Button>
                        <Button variant='contained' className='bg-secondary-500 hover:bg-secondary-500 ml-4 w-[100px]' onClick={() => {
                            setShowAdvanceFilter(false)
                        }}>
                            View
                        </Button>
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default Submission